import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { TemplateMigrationPreviewLoader } from '@confluence/template-migration-preview';

export const TemplateMigrationPreviewRoute: {
	({ params: { contentId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { contentId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
			};
			pageState: {
				routeName: string;
				contentId: string;
			};
		};
		MainLayout: boolean;
	};
} = ({ params: { contentId } }: RouteMatch): React.JSX.Element => (
	<TemplateMigrationPreviewLoader templateId={contentId} />
);

TemplateMigrationPreviewRoute.NAVIGATION_PARAMS = ({
	name,
	params: { contentId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
		};
		pageState: {
			routeName: string;
			contentId: string;
		};
	};
	MainLayout: boolean;
} => ({
	Screen: {
		screenEvent: { name: 'templateMigrationPreviewScreen' },
		pageState: {
			routeName: name,
			contentId,
		},
	},
	MainLayout: false,
});
